module.exports = __webpack_public_path__ + "static/media/envelope-gray.7d85d456.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/envelope-gray.svg
// module id = 1814
// module chunks = 0